/* import __COLOCATED_TEMPLATE__ from './service-select-redesign.hbs'; */
import { classNames } from '@ember-decorators/component';
import RequestServiceSelect from './service-select';
import styles from './service-select-redesign.module.scss';

@classNames('service-select text-left justify-content-between', styles.component)
export default class RequestServiceSelectRedesign extends RequestServiceSelect {
  styles = styles;
}
